import type { MenuItem } from '@teemill/modules/menu';

import { defineStore } from 'pinia';
import { faBuildings } from '@fortawesome/pro-light-svg-icons';
import type { RouteLocationRaw } from 'vue-router';
import { useRouter } from 'vue-router';
import { computed, ref } from 'vue';

export interface Organisation {
  id: string;
  name: string;
}

export const useOrganisationStore = defineStore('organisation', () => {
  const router = useRouter();

  const ready = ref(false);
  const organisations = ref<Organisation[]>([]);
  const menu = ref<MenuItem[]>([
    {
      name: 'organisations.list',
      title: 'Organisations',
      to: { name: 'organisations' },
      icon: faBuildings,
      order: 1,
    },
  ]);
  const redirect = ref<RouteLocationRaw>();

  const active = computed((): Organisation | undefined => organisations.value[0]);

  const activeMenu = computed((): MenuItem[] => {
    if (active.value === undefined) {
      return [];
    }

    return menu.value;
  });

  const find = (organisation: string) =>
    computed(() => organisations.value.find((p: Organisation) => p.id === organisation));

  const update = (updatedOrganisations: Organisation[]) => {
    organisations.value = updatedOrganisations;

    router.isReady().then(() => {
      ready.value = true;
    });
  };

  const updateRedirect = (updatedRedirect?: RouteLocationRaw) => {
    redirect.value = updatedRedirect;
  };

  return {
    ready,
    organisations,
    menu,
    redirect,
    active,
    activeMenu,
    find,
    update,
    updateRedirect,
  };
});
